import React, { Component } from 'react';
import { observer, Provider } from 'mobx-react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';

//importing stores
import stores from '../stores';
const { AuthenticationStore } = stores;

//importing components
import AuthenticatedArea from './AuthenticatedArea';

//importing pages
import { Login, PostDetail, OnMobile } from '../screens';
import config from 'config';

const PostDetailWrapper = (props) => (
  <div className="shared-post-detail">
    <PostDetail {...props} titleElement={(
      <section>
        <div className="center-content">
          <img src={require('../img/logo.svg')} alt="" />
        </div>
      </section>
    )} />
  </div>
);

@observer
export default class App extends Component {
  constructor(props, context) {
    super(props, context);
    document.documentElement.style.setProperty('--themeColor', config.color)
  }

  componentWillMount() {
    AuthenticationStore.validate();
  }



  render() {
    return (
      <Provider {...stores}>
        <Router>
          <div>
            <Route path="/novidade/:slug" component={PostDetailWrapper} />
            {(AuthenticationStore.user || AuthenticationStore.isChecked) &&
              <Route render={({ location }) => (
                <div>
                  {!(/\/novidade\//.test(location.pathname)) && <OnMobile />}

                  <Route exact path="/" render={() => (
                    <div>
                      {AuthenticationStore.userCanAccess && <Redirect to="/novidades" />}
                    </div>
                  )} />

                  {AuthenticationStore.userCanAccess && <AuthenticatedArea location={location} />}

                  <Route path="/login" component={Login} />

                  <Route render={({ location }) => {
                    if (/\/novidade\//.test(location.pathname) || location.pathname == '/login' || AuthenticationStore.userCanAccess) { return null; }
                    return <Redirect to="/login" />
                  }} />

                </div>
              )} />
            }
          </div>
        </Router>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js